import React, { createContext } from 'react';

export const RegisterContext = createContext();


